var _defs, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #cb0018;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #00376d;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #007292;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2.43px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.72,64.29h-21.43c-4.69,0-9.18,1.85-12.52,5.14-3.33,3.29-5.24,7.76-5.31,12.45.07,4.69,1.98,5.21,5.31,8.5,3.34,3.29,7.83,5.14,12.52,5.14h21.43c4.68,0,9.18-1.85,12.51-5.14,3.34-3.29,5.24-3.81,5.31-8.5-.07-4.69-1.97-9.16-5.31-12.45-3.33-3.29-7.83-5.14-12.51-5.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.86,39.29c0,3.53-1.05,6.98-3.01,9.92-1.96,2.93-4.75,5.22-8.01,6.57-3.27,1.36-6.86,1.71-10.32,1.02-3.47-.69-6.65-2.39-9.14-4.89-2.5-2.49-4.2-5.68-4.89-9.14-.69-3.46-.34-7.06,1.01-10.32,1.36-3.26,3.64-6.05,6.58-8.01,2.94-1.96,6.39-3.01,9.92-3.01,4.74,0,9.28,1.88,12.63,5.23,3.35,3.35,5.23,7.89,5.23,12.63Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.75,85.83c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 71.75,
    cy: 71.83,
    r: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 66.98,
    y1: 76.6,
    x2: 76.51,
    y2: 67.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 66.98,
    y1: 67.06,
    x2: 76.51,
    y2: 76.6
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.34,14.66C37.15-30.63-30.62,37.2,14.65,85.36c48.18,45.25,115.98-22.54,70.69-70.7ZM50,92.95C17.38,93.78-4.17,55.43,13.13,27.95,26.27,4.61,61.07-.03,79.85,19.12c27.7,25.24,7.81,75.01-29.85,73.83Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginoff);
export default __webpack_public_path__ + "static/media/loginoff.49a63b07fff8b947c7bbb097cc274e51.svg";
export { ForwardRef as ReactComponent };